// @ts-strict

import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { IToggleSwitchStateData } from '@app/core/models/core-models';

export interface SwitchOption {
  settingName: string;
  status: boolean;
}

@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss']
})
export class ToggleSwitchComponent implements OnChanges {
  @Input() controlled = false;
  @Input() disabled?: boolean;
  @Input() settingName?: string;
  @Input() tooltipText?: string;
  @Input() fontSize?: number;
  @Input() settingValue?: boolean;
  @Input() notificationType?: string;
  @Input() inputName?: string;
  @Input() nameTranslationKey?: string;
  @Input() textEllipsis?: boolean;
  @Input() large = false;
  @Input() reverted = false;

  @Output() settingStatus = new EventEmitter<{
    settingName: string;
    status: boolean;
  }>();
  @Output() emitChange = new EventEmitter<IToggleSwitchStateData>();

  public statusSetting = false;

  ngOnChanges(): void {
    if (this.settingValue !== undefined) {
      this.statusSetting = this.settingValue;
    }
  }

  public switchSetting(settingName: string): void {
    if (this.disabled) {
      return;
    }

    if (!this.controlled) {
      this.statusSetting = !this.statusSetting;
      this.settingStatus.emit({
        settingName: `${settingName}`,
        status: this.statusSetting
      });

      return this.emitChange.emit({ setting: settingName, state: this.statusSetting });
    }

    return this.emitChange.emit({ setting: settingName, state: this.statusSetting });
  }
}
